module.exports = __webpack_public_path__ + "img/bannerimg.0027a6f3.png";